'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
require('../../../../../aviary-core/dist/cjs/index.cjs');
var Pill_web = require('../../atoms/Pill/Pill.web.cjs');
var index = require('../../../../../../_virtual/index.cjs');

/**
 * Pill to indicate content is featured by Fullscript
 *
 * @scope Platform
 */ const PreferredPill = ({ ...rest })=>{
    return /*#__PURE__*/ jsxRuntime.jsx(Pill_web.Pill, {
        svgUrl: {
            lightMode: index.__exports.FullscriptBadgeLogoLight,
            darkMode: index.__exports.FullscriptBadgeLogoDark
        },
        labelContent: "Top pick",
        backgroundColor: "forest",
        tooltipContent: "Meets select criteria for quality, clinical utility, and evidence",
        ...rest
    });
};

exports.PreferredPill = PreferredPill;
//# sourceMappingURL=PreferredPill.web.cjs.map
